// SETTING UP REDUX TOOLKIT FOR AUTH SLICE
import { createSlice } from "@reduxjs/toolkit";

const isUserVerified = (user) => {
  if (!user) return false;

  const emailVerified =
    user.email_verified_at && user.email_verified_at !== null;
  const phoneVerified =
    user.phone_number_verified_at && user.phone_number_verified_at !== null;

  return emailVerified || phoneVerified;
};

const loadInitialState = () => {
  const user = localStorage.getItem("dbx_aff_usr");
  const token = localStorage.getItem("dbx_aff_tkn");
  const tempUser = localStorage.getItem("dbx_aff_temp_user");
  const verificationEmail = localStorage.getItem("dbx_aff_verification_email");

  if (tempUser && verificationEmail) {
    try {
      const parsedTempUser = JSON.parse(tempUser);
      return {
        user: parsedTempUser,
        token: null,
        isAuthenticated: true,
        isVerified: false,
        isInVerificationProcess: true,
      };
    } catch (error) {
      localStorage.removeItem("dbx_aff_temp_user");
      localStorage.removeItem("dbx_aff_verification_email");
    }
  }

  if (token) {
    if (user) {
      try {
        const parsedUser = JSON.parse(user);
        const verified = isUserVerified(parsedUser);

        return {
          user: parsedUser,
          token: token,
          isAuthenticated: true,
          isVerified: verified,
          isInVerificationProcess: false,
        };
      } catch (error) {
        localStorage.removeItem("dbx_aff_usr");
        localStorage.removeItem("dbx_aff_tkn");
        return {
          user: null,
          token: null,
          isAuthenticated: false,
          isVerified: false,
          isInVerificationProcess: false,
        };
      }
    } else {
      localStorage.removeItem("dbx_aff_tkn");
      return {
        user: null,
        token: null,
        isAuthenticated: false,
        isVerified: false,
        isInVerificationProcess: false,
      };
    }
  }

  if (user) {
    try {
      const parsedUser = JSON.parse(user);
      const verified = isUserVerified(parsedUser);

      return {
        user: parsedUser,
        token: null,
        isAuthenticated: false,
        isVerified: verified,
        isInVerificationProcess: false,
      };
    } catch (error) {
      localStorage.removeItem("dbx_aff_usr");
      return {
        user: null,
        token: null,
        isAuthenticated: false,
        isVerified: false,
        isInVerificationProcess: false,
      };
    }
  }

  return {
    user: null,
    token: null,
    isAuthenticated: false,
    isVerified: false,
    isInVerificationProcess: false,
  };
};

const authSlice = createSlice({
  initialState: loadInitialState(),
  name: "auth",
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.token = action.payload.token;
      state.isVerified = isUserVerified(action.payload);
      localStorage.setItem("dbx_aff_usr", JSON.stringify(action.payload));
      localStorage.setItem("dbx_aff_tkn", action.payload.token);
      state.isAuthenticated = true;
    },
    setUserFromVerification: (state, action) => {
      const userData = action.payload;
      
      state.user = userData;
      state.token = userData.token || null;
      state.isVerified = isUserVerified(userData);
      state.isAuthenticated = true;
      state.isInVerificationProcess = !userData.token;

      // Store in localStorage
      localStorage.setItem("dbx_aff_usr", JSON.stringify(userData));
      if (userData.token) {
        localStorage.setItem("dbx_aff_tkn", userData.token);
      }
    },
    updateUser: (state, action) => {
      state.user = action.payload;
      state.isVerified = isUserVerified(action.payload);
      state.isAuthenticated = !!state.token;
      localStorage.setItem("dbx_aff_usr", JSON.stringify(action.payload));
    },
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem("dbx_aff_tkn", action.payload);
      state.isAuthenticated = true;
    },
    clearUser: (state) => {
      state.user = null;
      state.token = null;
      state.isVerified = false;
      state.isInVerificationProcess = false;
      localStorage.removeItem("dbx_aff_tkn");
      localStorage.removeItem("dbx_aff_usr");
      localStorage.removeItem("dbx_aff_temp_user");
      localStorage.removeItem("dbx_aff_verification_email");
      state.isAuthenticated = false;
    },
  },
});

export const {
  setUser,
  setUserFromVerification,
  setToken,
  updateUser,
  clearUser,
} = authSlice.actions;
export default authSlice.reducer;
